import { tr } from 'i18n';
export const ACCESS_LABELS = {
  reports: "Отчёты", guards: "Охрана", top_bases: "ТОП-базы", chpps: "ТЭЦ",
  private_points: "Социальные объекты", loads: "Погрузки", drivers: "Водители",
  requests: "Заявки на базы", confirmations: "Подтверждения", drivers_edit: "Редактирование водителей",
  drivers_pin: "Сброс PIN", drivers_block: "Блокировка и разблокировка",
  operators_pin: "Сброс PIN оператор",
  operators_inn: "Смена ИНН операторам",
  guards_pin: "Сброс PIN охраны",
  guards_inn: "Смена ИНН охраны",
  branches_delete: "Удаление филиалов",
  drivers_active: "Изменение активности водителей",
  drivers_inn: "Смена ИНН водителям",
  drivers_assign: "Переназначение водителей",
  drivers_base_assign: "Назначение базы",
  drivers_base_change: "Смена базы",
  drivers_base_remove: "Снятие с базы",
  users: "Управление пользователями", audit: "Логирование",
}
export function hasAccess(user, key) {
  if (!user) return false
  if (user.is_superuser || user.erp_role === 'superuser') return true
  if (user.erp_role === 'reporter' || user.is_report_only) return key === 'reports'
  return !!user.erp_access?.[key]
}
export const DRIVER_ACCESS_KEYS = ['drivers', 'drivers_edit', 'drivers_pin', 'drivers_block', 'drivers_active', 'drivers_inn', 'drivers_assign', 'drivers_base_assign', 'drivers_base_change', 'drivers_base_remove']
export const canViewDrivers = user => DRIVER_ACCESS_KEYS.some(key => hasAccess(user, key))
export const GUARD_ACCESS_KEYS = ['guards', 'guards_pin', 'guards_inn']
export const canViewGuards = user => GUARD_ACCESS_KEYS.some(key => hasAccess(user, key))
export const canAccessAdmin = user => [...GUARD_ACCESS_KEYS, 'top_bases', 'chpps', 'private_points', 'loads', ...DRIVER_ACCESS_KEYS, 'users', 'audit'].some(key => hasAccess(user, key))
export const canAccessRequests = user => user?.erp_role === 'driver' || user?.erp_role === 'operator' || hasAccess(user, 'requests') || hasAccess(user, 'confirmations')
export const isOperational = user => ['driver', 'guard', 'operator', 'base_operator'].includes(user?.erp_role)
export function getHomePath(user) {
  if (user?.is_superuser || user?.erp_role === 'superuser') return '/adminpanel/'
  if (isOperational(user)) return '/report-card/'
  if (canAccessAdmin(user)) return '/adminpanel/'
  if (hasAccess(user, 'reports')) return '/reports/'
  if (canAccessRequests(user)) return '/requests/'
  if (user?.erp_role === 'employee' || (!user?.erp_role && user?.is_personal_kyrgyzkomur)) return '/employee-card/'
  return '/workspace/'
}
export function getRoleLabel(user) {
  return ({ superuser: tr("Суперпользователь"), administrator: tr("Администратор"), admin: tr("Администратор"), reporter: tr("Только отчёты"), driver: tr("Водитель"), guard: tr("Охрана"), operator: tr("Оператор базы"), base_operator: tr("Оператор базы"), employee: tr("Сотрудник Кыргызкомур"), user: tr("Пользователь") })[user?.erp_role] || tr("Пользователь")
}
